'use client';
import React, { useEffect, useRef, useState } from 'react';

function useInView(threshold = 0.1) {
  const ref = useRef<HTMLDivElement>(null);
  const [inView, setInView] = useState(false);

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {if (entry.isIntersecting) setInView(true);},
      { threshold }
    );
    if (ref?.current) observer?.observe(ref?.current);
    return () => observer?.disconnect();
  }, [threshold]);

  return { ref, inView };
}

export default function CtaBox() {
  const { ref, inView } = useInView();

  return (
    <div className="cta-box">
      <div className="dentaire-container">
        <div className="row align-items-center" ref={ref}>
          {/* Phone */}
          <div className="col-lg-4 col-md-6 col-12">
            <div
              className="cta-box-item"
              style={{
                opacity: inView ? 1 : 0,
                transform: inView ? 'translateY(0)' : 'translateY(30px)',
                transition: 'opacity 0.6s ease, transform 0.6s ease'
              }}>
              
              <div className="icon-box">
                <img src="https://html.awaikenthemes.com/dentaire/images/icon-cta-phone.svg" alt="Phone icon" />
              </div>
              <div className="cta-box-content">
                <h3>besoin d'une consultation ?</h3>
                <p>Appelez-nous : (+225) 27 22 00 00 00</p>
              </div>
            </div>
          </div>

          {/* Hours */}
          <div className="col-lg-4 col-md-6 col-12">
            <div
              className="cta-box-item"
              style={{
                borderRight: 'none',
                paddingRight: 0,
                marginRight: 0,
                opacity: inView ? 1 : 0,
                transform: inView ? 'translateY(0)' : 'translateY(30px)',
                transition: 'opacity 0.6s ease 0.25s, transform 0.6s ease 0.25s'
              }}>
              
              <div className="icon-box">
                <img src="https://html.awaikenthemes.com/dentaire/images/icon-cta-time.svg" alt="Time icon" />
              </div>
              <div className="cta-box-content">
                <h3>horaires d'ouverture</h3>
                <p>Lun au Sam 8h00 à 20h00</p>
              </div>
            </div>
          </div>

          {/* Button */}
          <div className="col-lg-4 col-md-12 col-12">
            <div
              className="cta-box-btn"
              style={{
                opacity: inView ? 1 : 0,
                transform: inView ? 'translateY(0)' : 'translateY(30px)',
                transition: 'opacity 0.6s ease 0.5s, transform 0.6s ease 0.5s'
              }}>
              
              <a href="#" className="btn-default btn-highlighted">prendre rendez-vous</a>
            </div>
          </div>
        </div>
      </div>
    </div>);

}